export default {
  lectureCountList: [],
  courseList: [],
  lectureOption: null,
  lectureSeries: [],
  subjectOption: null,
  subjectSeries: [],
  chapterOption: null,
  chapterSeries: [],
  genderSeries: [],
  genderChartOptions: {},
  countrySeries: [],
  countryChartOptions: {},
  userCourseSeries: [],
  userCourseChartOptions: {},
  isFreeSeries: [],
  isFreeOptions: {},
  courseDurationSeries: [],
  courseDurationOptions: {},
  topVideoSeries: [],
  topVideoChartOptions: {},
  liveStreamingNumber: Number,
  lastDayVideoCount: Number,
  lastDayExamCount: Number,
  currentlyExamParticipant: Number,
  activeUserNumber: Number,
  courseTypeList: [],
  usersList: []
}
